module.exports = __webpack_public_path__ + "img/podcast-view.22885249.jpeg";